'use strict';

define('opts',['jquery'], function ($) {

  var _ua = navigator.userAgent.toLowerCase();

  var _breakpoints = {
    mobile: 640,
    tablet: 1000
  };

  var _browser = {
      version: (_ua.match( /.+(?:me|ox|on|rv|it|era|opr|ie)[\/: ]([\d.]+)/ ) || [0,'0'])[1],
      opera: (/opera/i.test(_ua) || /opr/i.test(_ua)),
      msie: (/msie/i.test(_ua) && !/opera/i.test(_ua) || /trident\//i.test(_ua)),
      msie6: (/msie 6/i.test(_ua) && !/opera/i.test(_ua)),
      msie7: (/msie 7/i.test(_ua) && !/opera/i.test(_ua)),
      msie8: (/msie 8/i.test(_ua) && !/opera/i.test(_ua)),
      msie9: (/msie 9/i.test(_ua) && !/opera/i.test(_ua)),
      mozilla: /firefox/i.test(_ua),
      chrome: /chrome/i.test(_ua),
      safari: (!(/chrome/i.test(_ua)) && /webkit|safari|khtml/i.test(_ua)),
      iphone: /iphone/i.test(_ua),
      ipod: /ipod/i.test(_ua),
      iphone4: /iphone.*OS 4/i.test(_ua),
      ipod4: /ipod.*OS 4/i.test(_ua),
      ipad: /ipad/i.test(_ua),
      android: /android/i.test(_ua),
      bada: /bada/i.test(_ua),
      mobile: /iphone|ipod|ipad|opera mini|opera mobi|iemobile|android/i.test(_ua),
      msie_mobile: /iemobile/i.test(_ua),
      safari_mobile: /iphone|ipod|ipad/i.test(_ua),
      opera_mobile: /opera mini|opera mobi/i.test(_ua),
      opera_mini: /opera mini/i.test(_ua),
      mac: /mac/i.test(_ua),
      search_bot: /(yandex|google|stackrambler|aport|slurp|msnbot|bingbot|twitterbot|ia_archiver|facebookexternalhit)/i.test(_ua)
    };

  var _getScreenWidth = function () {
    // if mobile/tablet and landscape orientation
    if (_browser.mobile && (window.orientation === 90 || window.orientation === -90)) {
      return window.screen.availHeight;
    }
    else {
      return window.screen.availWidth;
    }
  };

  var _getScreenHeight = function () {
    // if mobile/tablet and landscape orientation
    if (_browser.mobile && (window.orientation === 90 || window.orientation === -90)) {
      return window.screen.availWidth;
    }
    else {
      return window.screen.availHeight;
    }
  };

  var _getBrowserHeight = function() {
    return $(window).height();
  };

  var _getBrowserWidth = function () {
    var e = window, a = 'inner';
    if (!('innerWidth' in window )) {
      a = 'client';
      e = document.documentElement || document.body;
    }
    return e[ a+'Width' ];
  };

  var _isMobileScreen = function() {
    return (_getBrowserWidth() <= _breakpoints.mobile);
  };

  var _isDesktopScreen = function() {
    return (_getBrowserWidth() > _breakpoints.tablet);
  };

  var _isTabletScreen = function() {
    return (_getBrowserWidth() > _breakpoints.mobile && _getBrowserWidth() <= _breakpoints.tablet);
  };

  var _getCurrentBreakpoint = function() {
    if(_isMobileScreen()) {
      return 'mobile';
    }
    else if(_isTabletScreen()) {
      return 'tablet';
    }
    else {
      return 'desktop';
    }
  };

  return {
    browser: _browser,
    getScreenHeight: _getScreenHeight,
    getScreenWidth: _getScreenWidth,
    getBrowserHeight: _getBrowserHeight,
    getBrowserWidth: _getBrowserWidth,
    isMobileScreen: _isMobileScreen,
    isDesktopScreen: _isDesktopScreen,
    isTabletScreen: _isTabletScreen,
    breakpoints: _breakpoints,
    getCurrentBreakpoint: _getCurrentBreakpoint
  };
});
